import React from 'react';
import { Form } from 'react-bootstrap';
import { FormData } from './types';

interface RightColumnFormProps {
  formData: FormData;
  handleChange: (field: string, value: any) => void;
}

const RightColumnForm: React.FC<RightColumnFormProps> = ({ formData, handleChange }) => {
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Besøk poststed</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn besøk poststed"
          value={formData.besokpoststed}
          onChange={(e) => handleChange('besokpoststed', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>E-post</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn epost"
          value={formData.epost}
          onChange={(e) => handleChange('epost', e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Fakturaadresse</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn Fakturaadresse"
          value={formData.fakturaadresse}
          onChange={(e) => handleChange('fakturaadresse', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Faktura postnummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn faktura postnummer"
          value={formData.fakturapostnummer}
          onChange={(e) => handleChange('fakturapostnummer', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Faktura poststed</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn faktura poststed"
          value={formData.fakturapoststed}
          onChange={(e) => handleChange('fakturapoststed', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Faktura e-post</Form.Label>
        <Form.Control
          type="email"
          placeholder="Skriv inn faktura e-post"
          value={formData.fakturaEpost}
          onChange={(e) => handleChange('fakturaEpost', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Post adresse</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn post adresse"
          value={formData.postadresse}
          onChange={(e) => handleChange('postadresse', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Postnummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn postnummer"
          value={formData.postnummer}
          onChange={(e) => handleChange('postnummer', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Post poststed</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn post poststed"
          value={formData.postpoststed}
          onChange={(e) => handleChange('postpoststed', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Kommentar</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn kommentar"
          value={formData.kommentar}
          onChange={(e) => handleChange('kommentar', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Leverandørkundenummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn Leverandørkundenummer"
          value={formData.leverandorkundenummer}
          onChange={(e) => handleChange('leverandorkundenummer', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Leverandørkundenummer hos</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn Leverandørkundenummer hos"
          value={formData.leverandorkundenummerhos}
          onChange={(e) => handleChange('leverandorkundenummerhos', e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Kundenummer hos grossist</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn Kundenummer hos grossist"
          value={formData.kundenummerhossgrossist || ''}
          onChange={(e) => handleChange('kundenummerhossgrossist', e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Bransjeforslag</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn bransjeforslag"
          value={formData.bransjeforslag}
          onChange={(e) => handleChange('bransjeforslag', e.target.value)}
        />
      </Form.Group>
    </>
  );
};

export default RightColumnForm;
